"use strict";

require("core-js/modules/es6.date.to-json");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ForOfAdaptor_1 = require("../iterator/ForOfAdaptor");
/**
 * Basic container.
 *
 * @author Jeongho Nam <http://samchon.org>
 */


var Container =
/** @class */
function () {
  function Container() {}
  /**
   * @inheritDoc
   */


  Container.prototype.clear = function () {
    this.erase(this.begin(), this.end());
  };
  /**
   * @inheritDoc
   */


  Container.prototype.empty = function () {
    return this.size() === 0;
  };
  /**
   * @inheritDoc
   */


  Container.prototype.rbegin = function () {
    return this.end().reverse();
  };
  /**
   * @inheritDoc
   */


  Container.prototype.rend = function () {
    return this.begin().reverse();
  };
  /**
   * @inheritDoc
   */


  Container.prototype[Symbol.iterator] = function () {
    return new ForOfAdaptor_1.ForOfAdaptor(this.begin(), this.end());
  };
  /**
   * @inheritDoc
   */


  Container.prototype.toJSON = function () {
    var e_1, _a;

    var ret = [];

    try {
      for (var _b = __values(this), _c = _b.next(); !_c.done; _c = _b.next()) {
        var elem = _c.value;
        ret.push(elem);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return ret;
  };

  return Container;
}();

exports.Container = Container;